export default {
  "translation": {
    "card_application": "การสมัครบัตร",
    "card_application_des": "รับบัตร Sonic และใช้ที่ผู้ค้ากว่า 44 ล้านแห่งที่เปิดใช้งาน Visa ทั่วโลก",
    "spend_your_crypto_like_fiat": "ใช้คริปโตของคุณเหมือนเงินตรา",
    "use_globally_across_borders": "ใช้ได้ทั่วโลก ข้ามพรมแดน",
    "ultra_low_trans_costs": "ค่าธรรมเนียมการทำธุรกรรมต่ำสุด",
    "seamless_and_secure": "สะดวกและปลอดภัย",
    "two_factor_verification": "การตรวจสอบแบบสองขั้นตอน",
    "two_factor_verification_des": "เข้าสู่ระบบอย่างปลอดภัยโดยใช้ อีเมล โทรศัพท์ ชีวภาพ และ/หรือแอปตรวจสอบ",
    "safety_pin": "รหัส PIN ความปลอดภัย",
    "safety_pin_des": "จำกัดการเข้าถึงข้อมูลส่วนตัวโดยการตั้งค่า PIN",
    "trans_3ds_verification": "การตรวจสอบ 3DS",
    "trans_3ds_verification_des": "อนุมัติการซื้อก่อนที่พวกเขาจะถูกประมวลผล",
    "additional_security": "ความปลอดภัยเพิ่มเติม",
    "additional_security_des": "ตั้งค่าขีดจำกัดบัตรและฟีเจอร์ความปลอดภัยอื่น ๆ ในแอปได้อย่างง่ายดาย",
    "get_your_redotpay_card_in_steps": "รับบัตร Sonic ของคุณใน 3 ขั้นตอนง่ายๆ",
    "get_your_redotpay_card_subtitle": "ใช้คริปโตเหมือนเงินทั่วไป: ได้รับการยอมรับจากร้านค้ากว่า 44 ล้านแห่งทั่วโลกที่รองรับ Visa",
    "continue_key": "ดำเนินการต่อ",
    "bind_your_mobile_number": "เชื่อมโยงหมายเลขมือถือของคุณ",
    "complete_identity_verification": "ทำการตรวจสอบตัวตนให้เสร็จสิ้น",
    "apply_a_virtual_or_physical_card": "สมัครบัตรเสมือนหรือบัตรจริง",
    "transactions": "ธุรกรรม",
    "need_mobile_bind_confirm": "ต้องเชื่อมโยงมือถือก่อน",
    "info": "ข้อมูล",
    "card_trans_status_refund_pending": "รอการคืนเงิน",
    "card_trans_status_refund_success": "คืนเงินสำเร็จ",
    "card_trans_status_refund_fail": "คืนเงินล้มเหลว",
    "card_trans_status_refund_wait": "รอการคืนเงิน",
    "card_trans_status_pending": "ได้รับการอนุมัติ",
    "card_trans_status_cleared": "เรียบร้อย",
    "card_trans_status_declined": "ปฏิเสธ",
    "card_trans_status_canceled": "ย้อนกลับ",
    "card_trans_status_refund": "คืนเงิน",
    "card_trans_status_refund_cancel": "ยกเลิกการคืนเงิน",
    "refund": "คืนเงิน",
    "transaction_list": "รายการธุรกรรม",
    "more": "เพิ่มเติม",
    "top_questions": "คำถามที่พบบ่อย",
    "faq": "คำถามที่พบบ่อย",
    "self_service": "บริการด้วยตนเอง",
    "support_center": "ศูนย์สนับสนุน",
    "hello": "สวัสดี",
    "updated_on": "อัปเดตเมื่อ",
    "chat_with_us": "แชทกับเรา",
    "warning": "คำเตือน",
    "security_option_change_alert_prompt": "หลังจากที่คุณยกเลิก/เปลี่ยน Google Authenticator/มือถือ/อีเมล/PIN การถอนและการโอนภายในจะถูกปิดใช้งาน และการทำธุรกรรมบัตรจะถูกจำกัดที่ $1000 ต่อธุรกรรมใน 24 ชั่วโมงถัดไป aus.",
    "cancel": "ยกเลิก",
    "ok": "ตกลง",
    "account_deletion_regret_promp": "การลบบัญชีจะมีระยะเวลาการเสียใจ 15 วัน เมื่อคุณเข้าสู่ระบบอีกครั้งภายใน 15 วันหลังจากที่คุณสมัครลบ การสมัครของคุณจะถูกยกเลิก และบัญชีของคุณสามารถใช้งานได้ตามปกติ",
    "view_on_blockchain_explorer": "ดูในบล็อกเชนสำรวจ",
    "biz_sn": "หมายเลขธุรกรรม",
    "type": "ประเภท",
    "create_time": "เวลาสร้าง",
    "logout_confirm": "คุณแน่ใจหรือว่าต้องการออกจากระบบ?",
    "wallet": "กระเป๋าเงิน",
    "continue_with_google": "ดำเนินการต่อด้วย Google",
    "insufficient_balance_deposit_guide": "ยอดเงินไม่เพียงพอ โปรดฝากสินทรัพย์หรือลูกค้าของคุณจะถูกปฏิเสธและอาจมีค่าธรรมเนียม",
    "to": "ถึง",
    "bill_will_be_sent_to": "ใบแจ้งหนี้จะถูกส่งไปยัง",
    "bill_statement": "ใบแจ้งหนี้",
    "export_bill": "ส่งออกใบแจ้งหนี้",
    "this_month": "เดือนนี้",
    "last_month": "เดือนที่แล้ว",
    "last_3_month": "3 เดือนที่แล้ว",
    "this_year": "ปีนี้",
    "last_year": "ปีที่แล้ว",
    "customize": "ปรับแต่ง",
    "bill_export_success": "ใบแจ้งหนี้ได้ถูกส่งไปยังอีเมลของคุณ กรุณาตรวจสอบ",
    "bill_empty": "ใบแจ้งหนี้ของคุณว่างเปล่า",
    "channel": "ช่องทาง",
    "merchant_country": "ประเทศผู้ค้า",
    "status": "สถานะ",
    "withdraw_detail": "รายละเอียดการถอน",
    "new_key": "ใหม่",
    "deposit": "ฝาก",
    "withdraw": "ถอน",
    "single_limit": "ขีดจำกัดเดียว",
    "all": "ทั้งหมด",
    "minimum": "ขั้นต่ำ",
    "available": "ที่มีอยู่",
    "received_amount": "จำนวนที่ได้รับ",
    "withdrawl": "ถอน",
    "network_fee": "ค่าธรรมเนียมเครือข่าย",
    "register": "ลงทะเบียน",
    "register_login": "ลงทะเบียน/เข้าสู่ระบบ",
    "login": "เข้าสู่ระบบ",
    "email_Phone": "อีเมล/หมายเลขโทรศัพท์",
    "email": "อีเมล",
    "mobile": "มือถือ",
    "next": "ถัดไป",
    "or_continue_with": "หรือต่อด้วย",
    "forgot_pw": "ลืมรหัสผ่าน?",
    "welcome_to_redotpay": "ยินดีต้อนรับสู่ Sonic Pay",
    "verify_code": "รหัสยืนยัน",
    "get_code": "รับรหัส",
    "by_creating_an_account": "โดยการสร้างบัญชี คุณยอมรับ",
    "privacy_policy": "นโยบายความเป็นส่วนตัว",
    "terms_conditions": "ข้อกำหนดและเงื่อนไข",
    "and": "และ",
    "modify_pin": "เปลี่ยน PIN",
    "pin_subtitle": "รหัส PIN ความปลอดภัยให้การตรวจสอบอย่างรวดเร็ว ทำให้คุณสามารถดูหมายเลขบัตรและข้อมูล CVV ได้ง่าย",
    "password_set_first_login": "เข้าสู่ระบบครั้งแรกเพื่อตั้งรหัสผ่าน",
    "next_step": "ขั้นตอนถัดไป",
    "confirm": "ยืนยัน",
    "username": "ชื่อผู้ใช้",
    "password": "รหัสผ่าน",
    "send_code": "ส่งรหัส",
    "send_code_to": "รหัสจะถูกส่งไปที่",
    "switch_option": "เปลี่ยนตัวเลือกการตรวจสอบ",
    "mobile_verification": "การตรวจสอบมือถือ",
    "email_verification": "การตรวจสอบอีเมล",
    "choose_verify_method": "เปลี่ยนตัวเลือกการตรวจสอบ",
    "verify_pin": "รหัส PIN ความปลอดภัย",
    "google_authenticator_verification": "Google Authenticator",
    "security": "ความปลอดภัย",
    "bound": "เชื่อมโยง",
    "unbound": "ไม่เชื่อมโยง",
    "set": "ตั้งค่า",
    "unset": "ยกเลิกการตั้งค่า",
    "update_pw": "เปลี่ยนรหัสผ่าน",
    "delete_account": "ยกเลิกบัญชี",
    "google_authenticator": "Google Authenticator",
    "google_authenticator_subtitle": "Google Authenticator ปกป้องการถอนและบัญชีของคุณ",
    "download_install": "ดาวน์โหลด",
    "download_install_prompt": "คุณต้องดาวน์โหลดและติดตั้งแอป Authenticator (Google Authenticator) ก่อน",
    "backup_key": "กุญแจสำรอง",
    "save_backup_key": "บันทึกกุญแจสำรองนี้ในสถานที่ที่ปลอดภัย",
    "google_authenticator_code": "รหัส Google Authenticator",
    "email_subtitle": "การตรวจสอบอีเมลปกป้องการถอนและบัญชีของคุณ",
    "change_email": "เปลี่ยนอีเมล",
    "email_update": "อัปเดตอีเมล",
    "code": "รหัส",
    "mobile_subtitle": "การตรวจสอบมือถือปกป้องการถอนและบัญชีของคุณ",
    "change_mobile": "เปลี่ยนมือถือ",
    "mobile_update": "อัปเดตมือถือ",
    "mobile_bind": "เชื่อมโยงหมายเลขมือถือ",
    "email_bind": "เชื่อมโยงอีเมล",
    "old_password": "รหัสผ่านเก่า",
    "new_password": "รหัสผ่านใหม่",
    "new_password_confirm": "ยืนยันรหัสผ่านใหม่",
    "language": "ภาษา",
    "appearance": "รูปลักษณ์",
    "logout": "ออกจากระบบ",
    "log_out_toast": "คุณได้ออกจากระบบแล้ว",
    "set_pin": "รหัส PIN ความปลอดภัย",
    "account_deletion_prompt_1": "บัญชีนี้จะไม่สามารถกู้คืนได้",
    "account_deletion_prompt_2": "ผู้ใช้ย่อยทั้งหมด / บัญชีอื่น ๆ ที่สร้างโดยบัญชีนี้จะถูกลบและไม่สามารถกู้คืนได้",
    "account_deletion_prompt_3": "API keys ทั้งหมดที่เกี่ยวข้องกับบัญชีนี้จะถูกลบ",
    "account_deletion_prompt_4": "การถอนเงินที่ได้รับมอบหมายในปัจจุบันและที่รอการอนุมัติของบัญชีนี้จะถูกยกเลิก",
    "account_deletion_prompt_5": "ฟังก์ชันการทำธุรกรรมทั้งหมดของบัญชีนี้จะถูกปิดใช้งาน",
    "account_deletion_prompt_6": "สินทรัพย์ที่ไม่ได้ถอนจากบัญชีนี้จะถือว่าเป็นสินทรัพย์ที่ถูกละทิ้งโดยสมัครใจ",
    "account_deletion_prompt_7": "หลังจากที่คุณยื่นคำร้องขอลบบัญชี คุณจะมีระยะเวลาถอนเงิน 15 วัน เมื่อคุณเข้าสู่ระบบอีกครั้งภายใน 15 วันหลังจากคำร้องขอการลบ คำร้องขอลบของคุณจะถูกยกเลิกและบัญชีสามารถใช้งานได้ตามปกติ",
    "kyc_status_0": "ยังไม่ส่ง",
    "kyc_status_1": "กำลังตรวจสอบ...",
    "kyc_status_2": "ได้รับการอนุมัติ",
    "kyc_status_3": "ตรวจสอบล้มเหลว",
    "kyc_status_4": "ส่งใหม่",
    "kyc_status_5": "ส่งไปยังต้นน้ำ",
    "personal_info_review": "การตรวจสอบข้อมูลส่วนบุคคล",
    "additional_info_request": "ขอข้อมูลเพิ่มเติม",
    "verifying": "กำลังตรวจสอบ...",
    "form_submitted_will_review_asap_new": "ใบสมัครของคุณได้ถูกส่งไปยังการตรวจสอบด้วยมือ กระบวนการนี้มักใช้เวลา 3-5 วัน แต่บางครั้งอาจใช้เวลานานกว่านั้น กรุณารอสักครู่",
    "get_verified": "การตรวจสอบตัวตน",
    "kyc_verified": "ผู้ใช้ได้รับการยืนยันตัวตน",
    "approved": "อนุมัติ",
    "not_able_to_submit_identity": "ในกระบวนการตรวจสอบที่ครอบคลุม เราต้องการข้อมูลเพิ่มเติมจากคุณเพื่อให้เสร็จสิ้นกระบวนการตรวจสอบรู้จักลูกค้า (KYC) และการตรวจสอบการฟอกเงิน (AML)",
    "aml_review_failed": "เพื่อดำเนินการตามใบสมัครของคุณ กรุณาคลิกที่ปุ่มด้านล่างเพื่อเข้าถึงและกรอกแบบฟอร์มการประกาศตนเอง",
    "aml_declaration_prompt": "กรุณาทราบว่าหากไม่ส่งแบบฟอร์มที่ร้องขอภายใน 14 วันถัดไป ใบสมัครของคุณจะถูกปฏิเสธ",
    "verify_your_identity": "ยืนยันตัวตนของคุณ",
    "get_identity_verified": "ยืนยันตัวตนของคุณเพื่อซื้อและใช้บัตร",
    "country_region": "ประเทศ/ภูมิภาค",
    "given_name": "ชื่อ",
    "surname": "นามสกุล",
    "date_of_birth": "วันเกิด",
    "document_type": "ประเภทเอกสาร",
    "document_number": "หมายเลขเอกสาร",
    "given_name_intl": "ชื่อ (INTL)",
    "surname_intl": "นามสกุล (INTL)",
    "click_to_add_signature": "คลิกเพื่อเพิ่มลายเซ็น",
    "rewrite": "เขียนใหม่",
    "submit": "ส่ง",
    "save": "บันทึก",
    "accounts_are_not_available": "บัญชีไม่สามารถใช้งานได้",
    "abandon_assets": "ละทิ้งสินทรัพย์ {{amount}} {{currency}}",
    "account_deletion_successful": "การลบบัญชีสำเร็จ",
    "passwords_do_not_match": "รหัสผ่านไม่ตรงกัน",
    "password_reset_success": "การรีเซ็ตรหัสผ่านสำเร็จ",
    "password_confirm": "ยืนยันรหัสผ่าน",
    "is_refund": "คืนเงิน",
    "total_debt": "หนี้รวม",
    "your_account_is_in_arrears": "บัญชีของคุณค้างชำระ กรุณาฝากเงินเพียงพอเพื่อชำระยอดคงเหลือ บัญชี/บัตรของคุณจะถูกกู้คืนเมื่อยอดเงินของคุณ ≥10 USD หลังจากชำระหนี้",
    "repayment": "การชำระคืน",
    "debit_record": "บันทึกการถอน",
    "no_data": "ข้อมูลว่างเปล่า",
    "payment": "การชำระเงิน",
    "transaction_details": "รายละเอียดธุรกรรม",
    "transaction_date": "วันที่ทำธุรกรรม",
    "transaction_id": "หมายเลขธุรกรรม",
    "view_linked_order": "ดูคำสั่งที่เชื่อมโยง",
    "rights_interests": "สิทธิ์และผลประโยชน์",
    "transaction_limit": "ขีดจำกัดธุรกรรม",
    "deposit_withdraw": "ฝาก & ถอน",
    "card_purchased_number": "จำนวนบัตรที่สามารถซื้อได้",
    "on_review_your_applicant": "เรากำลังตรวจสอบใบสมัครของคุณ",
    "form_en_only": "แบบฟอร์มนี้สามารถกรอกเป็นภาษาอังกฤษเท่านั้น",
    "available_to_spend": "ใช้จ่ายได้",
    "get_a_card": "รับบัตร Sonic และใช้ที่ผู้ค้ากว่า 44 ล้านแห่งที่เปิดใช้งาน Visa ทั่วโลก",
    "virtual_card": "บัตรเสมือน",
    "physical_card": "บัตรจริง",
    "apply_card": "สมัครบัตร",
    "enjoy_seamless_spending": "ใช้จ่าย",
    "spend_and_withdraw": "ใช้จ่าย & ถอนเงินจาก ATM",
    "card_labeling": "การติดป้ายบัตร",
    "card_tag": "แท็กบัตร",
    "edit_billing_address": "ที่อยู่เรียกเก็บเงิน",
    "government_issued_id": "เอกสารประจำตัวที่ออกโดยรัฐบาล",
    "facial_recognition": "การรู้จำใบหน้า",
    "address": "ที่อยู่",
    "personnel_information_details": "รายละเอียดข้อมูลส่วนบุคคล",
    "nation_list": "รายการประเทศ",
    "choose_channel": "โหมดการตรวจสอบ",
    "mobile_channel_sms": "SMS",
    "mobile_channel_smsAliyunWhatsApp": "WhatsAPP",
    "card_application_order": "คำสั่งสมัครบัตร",
    "promo_code_optional": "รหัสโปรโมชั่น (ไม่บังคับ)",
    "promo_code": "รหัสโปรโมชั่น",
    "billing_address": "ที่อยู่เรียกเก็บเงิน",
    "shipping_address": "ที่อยู่จัดส่ง",
    "shipping_to": "จัดส่งไปยัง",
    "card_purchase_fee": "ค่าธรรมเนียมการซื้อบัตร",
    "card_holder_name": "ชื่อผู้ถือบัตร",
    "city": "เมือง",
    "province_state": "จังหวัด/รัฐ",
    "postal_code": "รหัสไปรษณีย์/ZIP",
    "address_line1": "ที่อยู่",
    "address_line2": "ที่อยู่บรรทัดที่ 2",
    "please_fill_in_the_information_in_english": "แบบฟอร์มนี้สามารถกรอกเป็นภาษาอังกฤษเท่านั้น",
    "first_name": "ชื่อ",
    "last_name": "นามสกุล",
    "country_code": "รหัสประเทศ",
    "card_application_list": "รายการสมัครบัตร",
    "buy_virtual_card": "ซื้อบัตรเสมือน",
    "buy_physical_card": "ซื้อบัตรจริง",
    "withdraw_list": "รายการถอน",
    "no_more_data": "ไม่มีข้อมูลเพิ่มเติม",
    "select_a_network": "เลือกเครือข่าย",
    "please_select_network": "กรุณาเลือกเครือข่าย",
    "select_a_network_ensure": "ให้แน่ใจว่าเครือข่ายที่คุณเลือกสำหรับการฝากตรงกับเครือข่ายการถอน มิฉะนั้นสินทรัพย์อาจสูญหาย",
    "network": "เครือข่าย",
    "card_management": "การจัดการบัตร",
    "freeze": "แช่แข็ง",
    "unfreeze": "ปลดแช่แข็ง",
    "freeze_card_des": "เมื่อเปิดใช้งานฟังก์ชันล็อกบัตรด้วยปุ่มเดียว คุณจะไม่สามารถใช้บัตรนี้ได้ แต่จะไม่ส่งผลต่อบัตรอื่น หากคุณต้องการยกเลิกฟังก์ชันล็อกบัตรด้วยปุ่มเดียว คุณสามารถเปิดใช้งานอีกครั้งที่นี่",
    "freezing_trades": "การแช่แข็งบัตรจะทำให้คำสั่งล้มเหลว ส่งผลให้การทำธุรกรรมล้มเหลวหรือค่าธรรมเนียมเพิ่มเติมสำหรับการซื้อขายที่ถูกปฏิเสธ",
    "unfreeze_your_card_desc": "เมื่อฟังก์ชันล็อกบัตรด้วยปุ่มเดียวถูกปิดใช้งาน คุณจะสามารถใช้บัตรนี้ได้อีกครั้ง และจะไม่ส่งผลต่อบัตรอื่น หากคุณต้องการแช่แข็งบัตร คุณสามารถทำได้ที่นี่อีกครั้ง",
    "card_tag_set_success": "ตั้งค่าแท็กบัตรสำเร็จ",
    "bill": "ใบแจ้งหนี้",
    "setting": "การตั้งค่า",
    "limit": "ขีดจำกัด",
    "assets_list": "รายการสินทรัพย์",
    "empty_data": "ข้อมูลว่างเปล่า",
    "deposit_list": "รายการฝาก",
    "date": "วันที่",
    "merchant_city": "เมืองผู้ค้า",
    "card_number": "หมายเลขบัตร",
    "card_type": "ประเภทบัตร",
    "mcc": "MCC",
    "declined_reason": "เหตุผลที่ถูกปฏิเสธ",
    "card_authorization_payment": "การชำระเงินด้วยการอนุญาตบัตร",
    "declined_transaction_fee": "ค่าธรรมเนียมธุรกรรมที่ถูกปฏิเสธ",
    "verified": "ได้รับการยืนยัน",
    "notifications": "การแจ้งเตือน",
    "need_to_add_bill_address": "ต้องเพิ่มที่อยู่เรียกเก็บเงิน",
    "need_to_add_shipping_address": "ที่อยู่สำหรับจัดส่งต้องไม่เว้นว่าง",
    "success": "สำเร็จ",
    "welcome_redotpay": "ยินดีต้อนรับสู่ Sonic Pay!",
    "reset_pw_alert": "หลังจากเปลี่ยนรหัสผ่าน การถอนและการโอนภายในจะถูกปิดใช้งาน และการทำธุรกรรมบัตรจะถูกจำกัดที่ $1000 ต่อธุรกรรมใน 24 ชั่วโมงถัดไป aus.",
    "no_more_records": "ไม่มีบันทึกเพิ่มเติม",
    "add": "เพิ่ม",
    "address_label": "ป้ายที่อยู่",
    "add_address": "เพิ่มที่อยู่",
    "this_field_is_required": "ฟิลด์นี้จำเป็นต้องกรอก",
    "ID_CARD": "บัตรประจำตัว",
    "PASSPORT": "หนังสือเดินทาง",
    "DRIVERS": "ใบขับขี่",
    "RESIDENCE_PERMIT": "ใบอนุญาตพำนัก",
    "amount": "จำนวนเงิน",
    "withdraw_status_waiting": "รอดำเนินการ",
    "withdraw_status_pending": "รอดำเนินการ",
    "withdraw_status_success": "สำเร็จ",
    "withdraw_status_fail": "ล้มเหลว",
    "withdraw_status_canceled": "ยกเลิก",
    "withdraw_status_declined": "ถูกปฏิเสธ",
    "withdraw_status_complete": "เสร็จสิ้น",
    "order_id": "หมายเลขคำสั่ง",
    "click_or_scroll_to_load_more": "คลิกหรือเลื่อนเพื่อโหลดเพิ่มเติม",
    "minimum_deposit_amount": "จำนวนเงินฝากขั้นต่ำ",
    "deposit_arrival_confirmations": "การฝากเข้ามา: {{confirmations}} การยืนยัน",
    "confirmations": "{{confirmations}} การยืนยัน",
    "deposit_network": "เครือข่ายฝาก",
    "minimum_deposit": "เงินฝากขั้นต่ำ",
    "deposit_arrival": "การฝากเข้ามา",
    "current_address_supports_depositing": "ที่อยู่ปัจจุบันสนับสนุนการฝาก {{varietyCode}} บน {{displayName}} เท่านั้น และสินทรัพย์อื่นจะสูญหาย",
    "copy_successful": "คัดลอกสำเร็จ",
    "update_password_successful": "อัปเดตรหัสผ่านสำเร็จ",
    "update_successful": "อัปเดตสำเร็จ",
    "successful": "สำเร็จ",
    "signature_required": "ต้องมีลายเซ็น",
    "deposit_successful": "ฝากสำเร็จ",
    "sign_out": "ออกจากระบบ",
    "cancel_withdraw_order_success": "การยกเลิกคำสั่งถอนสำเร็จ",
    "delete_successful": "ลบสำเร็จ",
    "unfreeze_card_successful": "ปลดแช่แข็งบัตรสำเร็จ",
    "card_nickname_set_success": "ตั้งชื่อเล่นบัตรสำเร็จ",
    "trans_limit_adjusted_success": "ปรับขีดจำกัดธุรกรรมสำเร็จ",
    "set_card_pin_success": "ตั้งค่าพินบัตรสำเร็จ",
    "withdraw_apply_commit_please_wait": "ส่งใบสมัครถอนเงินแล้ว กรุณารอ",
    "unfreeze_success": "ปลดแช่แข็งสำเร็จ",
    "freeze_success": "แช่แข็งสำเร็จ",
    "withdraw_duration_tip": "การสมัครถอนจะได้รับการดำเนินการภายในวันทำการหนึ่งวัน",
    "you_will_withdraw": "คุณจะถอน",
    "withdraw_info": "ข้อมูลการถอน",
    "please_confirm_same_network": "ตรวจสอบให้แน่ใจว่าเครือข่ายที่คุณเลือกสำหรับการฝากตรงกับเครือข่ายฝาก มิฉะนั้นสินทรัพย์อาจสูญหาย",
    "cancel_withdraw_order_confirm": "คุณแน่ใจว่าต้องการยกเลิกการถอนหรือไม่?",
    "valid_thru": "ใช้ได้จนถึง",
    "last_7_days": "7 วันที่ผ่านมา",
    "last_30_days": "30 วันที่ผ่านมา",
    "today": "วันนี้",
    "all_done": "ทำเสร็จทั้งหมด",
    "view_details": "ดูรายละเอียด",
    "withdraw_success": "ถอนเงินสำเร็จ",
    "pay": "ชำระเงิน",
    "fee": "ค่าธรรมเนียม",
    "discount": "ส่วนลด",
    "price": "ราคา",
    "card_application_details": "รายละเอียดการสมัครบัตร",
    "card_pin": "พินบัตร",
    "card_pin_format_helper": "ไม่สามารถมีตัวเลขเดียวกันสามตัวติดต่อกันหรือตัวเลขเรียงลำดับ",
    "digit_variable": "{{count}} หลัก",
    "address_book": "สมุดที่อยู่",
    "unlimited": "ไม่มีที่สิ้นสุด",
    "single": "เดี่ยว",
    "update_card_pin": "อัปเดตพินบัตร",
    "set_card_pin": "ตั้งค่าพินบัตร",
    "report_lost": "รายงานการสูญหาย",
    "report_lost_card": "รายงานบัตรสูญหาย",
    "card_lost_report_alert": "หลังจากรายงานการสูญหาย บัตรจะถูกปิดใช้งานและคุณจะไม่สามารถเปลี่ยนสถานะได้ หากคุณต้องการใช้บัตรอีกครั้งหรือลงทะเบียนบัตรใหม่ โปรดติดต่อทีมบริการลูกค้า",
    "pending": "รอดำเนินการ",
    "frozen": "แช่แข็ง",
    "phone_number": "หมายเลขโทรศัพท์",
    "search": "ค้นหา",
    "reset": "รีเซ็ต",
    "total_amount": "จำนวนเงินรวม",
    "actual_amount": "จำนวนเงินที่แท้จริง",
    "already_have_an_account": "มีบัญชีอยู่แล้ว?",
    "create_account": "สร้างบัญชี Sonic Pay",
    "total_balance": "ยอดรวมทั้งหมด",
    "cards_balance_available_promp": "วงเงินเครดิตคำนวณแบบเรียลไทม์ตามสินทรัพย์ในกระเป๋า",
    "got_it": "เข้าใจแล้ว",
    "review_details": "ตรวจสอบรายละเอียด",
    "delete_this_address": "คุณแน่ใจหรือว่าต้องการลบที่อยู่นี้?",
    "currency": "สกุลเงิน",
    "merchant_name": "ชื่อผู้ค้า",
    "request_time": "เวลาที่ขอ",
    "is_transaction_allowed": "การทำธุรกรรมนี้ได้รับอนุญาตหรือไม่?",
    "approve": "อนุมัติ",
    "decline": "ปฏิเสธ",
    "card_in_production": "บัตรกำลังผลิต",
    "redotpay_card_sent": "ส่งบัตร Redotpay แล้ว",
    "redotpay_card_activated": "เปิดใช้งานบัตร Redotpay แล้ว",
    "activate_card": "เปิดใช้งานบัตร",
    "paste": "วาง",
    "fees_included": "รวมค่าธรรมเนียม",
    "fx_fee": "ค่าธรรมเนียมการแลกเปลี่ยนเงินตรา",
    "small_auth_fee": "ค่าธรรมเนียมการทำธุรกรรมขนาดเล็ก",
    "atm_fee": "ค่าธรรมเนียม ATM",
    "received": "ได้รับแล้ว",
    "incremental": "ค่าธรรมเนียมเพิ่มขึ้น",
    "bill_address_save_success": "ที่อยู่ชำระเงินบันทึกสำเร็",
    "no_more_trans_record": "ไม่มีบันทึกการทำธุรกรรมเพิ่มເຕີม",
    "withdraw_amount_larger_than_available": "เกินยอดที่สามารถใช้งານได้สูงสุด",
    "withdraw_lower_than_min": "ต่ำกว่าจำนวนถอนλάχισท์",
    "card_is_deleted": "บัตรถືกลบ",
    "something_error": "มีบางสิ่งผิดปกติ",
    "home": "หน้าหลัก",
    "select_country": "เลือกประเทศ",
    "billing_list": "รายการบิล",
    "coupon_code": "รหัสส่วนลด",
    "password_rule1": "8 ถึง 32 ตัวอັກສร",
    "password_rule2": "อັງกฤษตัวใหญ่อย่างน้อย 1 ตัว",
    "password_rule3": "อັງกฤษตัวเล็กอย่างน้อย 1 ตัว",
    "password_rule4": "ตัวเลขอย่างน้อย 1 ตัว",
    "set_pw": "ตั้งรหัสผ่าน",
    "payment_currency_settings": "การตั้งค่าสกุลเงินการชำระเงิน",
    "customize_payment_currency": "ปรับแต่งสกุลเงินการชำระเงิน",
    "disable_non_local_tip": "การปิดใช้งานธุรกรรมด้วยสกุลเงินที่ไม่ใช่ท้องถิ่นสามารถลดความเสี่ยงของการฉ้อโกงบัตรได้อย่างมีประสิทธิภาพ",
    "charging_rules": "กฎการเรียกเก็บเงิน",
    "reissue_card": "ออกบัตรใหม่",
    "update_cvv": "อัปเดต CVV",
    "update_cvv_desc": "หมายเลขบัตรเดิม CVV ใหม่ และวันหมดอายุใหม่",
    "reissue_fee": "ค่าธรรมเนียมการออกบัตรใหม่",
    "fx_fee_desc": "ค่าธรรมเนียมการแลกเปลี่ยนเงินตราต่างประเทศ (FX Fee) รวม 1.2% ค่าธรรมเนียมธุรกรรมที่ไม่ใช่สกุลเงินเริ่มต้น (หากมี)",
    "atm_fee_desc": "จะมีการเรียกเก็บค่าธรรมเนียมเพิ่มเติม 2% สำหรับการถอนเงินแต่ละครั้งจากตู้ ATM",
    "remit_fee_desc": "ค่าธรรมเนียมสำหรับการใช้บัตรเครดิตหรือบัตรเดบิต Visa",
    "risk_safety_tips": "คำแนะนำด้านความปลอดภัย",
    "risk_safety": "ด้วยเหตุผลด้านความปลอดภัย กรุณาทำการยืนยันใบหน้าบนแอปให้เสร็จก่อนดำเนินการใด ๆ ที่เกี่ยวข้อง",
    "go_to_app_verify": "ไปที่แอปเพื่อยืนยัน",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "ไปที่ RedotPay ทันที",
    "close": "ปิด",
    "card_cancellation": "ยกเลิกบัตร",
    "delete_card": "ลบบัตร",
    "delete_card_desc": "บัตรจะไม่สามารถใช้งานได้หลังจากลบ และการดำเนินการนี้ไม่สามารถย้อนกลับได้",
    "deleting_fee": "ค่าธรรมเนียมการลบ",
    "currency_tips": "คำแนะนำเกี่ยวกับสกุลเงิน",
    "at_least_one_currency": "กรุณาเก็บสกุลเงินที่ชำระเงินได้อย่างน้อยหนึ่งสกุล",
    "all_select_currency": "คุณรองรับทุกสกุลเงินสำหรับการทำธุรกรรมแล้ว",
    "small_auth_transaction_fee_stas": "รายละเอียดค่าธรรมเนียมการทำธุรกรรมขนาดเล็ก",
    "small_transactions_this_month": "ธุรกรรมขนาดเล็กในเดือนนี้",
    "small_autn_trans_remain": "จำนวนธุรกรรมขนาดเล็กที่ได้รับการยกเว้นค่าธรรมเนียมในเดือนนี้",
    "rules": "กฎ",
    "failed_rules": "ธุรกรรมที่ล้มเหลวจะเพิ่มจำนวนบันทึกธุรกรรมที่ไม่ดี และจะมีการเรียกเก็บค่าธรรมเนียมเพิ่มเติมหากคุณเกิน โปรดควบคุมธุรกรรมให้เหมาะสม",
    "rule_item": "รายการ",
    "free_count": "จำนวนฟรี",
    "fees": "ค่าธรรมเนียม",
    "declined_trans_remain": "จำนวนธุรกรรมที่ถูกปฏิเสธที่ได้รับการยกเว้นค่าธรรมเนียมในเดือนนี้",
    "declined_transaction_fee_stats": "สถิติค่าธรรมเนียมธุรกรรมที่ถูกปฏิเสธ",
    "declined_rules": "ธุรกรรมที่ล้มเหลวจะเพิ่มจำนวนบันทึกธุรกรรมที่ไม่ดี และจะมีการเรียกเก็บค่าธรรมเนียมเพิ่มเติมหากคุณเกิน โปรดควบคุมธุรกรรมให้เหมาะสม",
    "declined_transactions_this_month": "จำนวนธุรกรรมที่ถูกปฏิเสธในเดือนนี้",
    "card_trans_detail_status_refund": "กำลังดำเนินการคืนเงิน",
    "card_trans_status_reversal": "การยกเลิก",
    "card_trans_status_fully_refund": "ดำเนินการเสร็จสิ้น คืนเงินเต็มจำนวน",
    "card_trans_status_partial_refund": "ดำเนินการเสร็จสิ้น คืนเงินบางส่วน",
    "card_trans_status_void": "โมฆะ",
    "first_time_free": "ฟรีสำหรับครั้งแรก",
    "FxFee": "ค่าธรรมเนียมการแลกเปลี่ยนเงินตราต่างประเทศ",
    "AtmFee": "ค่าธรรมเนียม ATM",
    "RemitFee": "ค่าธรรมเนียมการโอนเงิน",
    "MccFee": "ค่าธรรมเนียม MCC",
    "mcc_fee_desc": "ร้านค้าบางแห่งจะเรียกเก็บค่าธรรมเนียมเพิ่มเติม 1.5% ของจำนวนธุรกรรม หากค่าธรรมเนียมต่ำกว่า 0.5 USD จะมีการเรียกเก็บค่าธรรมเนียมขั้นต่ำ 0.5 USD",
    "please_deposit": "กรุณาฝากเงิน",
    "special_mcc_fee": "ค่าธรรมเนียม MCC พิเศษ",
    "bank_verifying": "การคืนเงินนี้กำลังอยู่ระหว่างการตรวจสอบโดยธนาคาร…",
    "estimate_time": "เวลาที่คาดว่าจะได้รับ: 2-30 วัน",
    "delete_out": "ยกเลิก",
    "card_is_loss": "บัตรถูกแจ้งหายแล้ว",
    "incremental_desc": "หากจำนวนเงินที่ได้รับอนุมัติไม่เพียงพอ จะมีการเรียกเก็บค่าธรรมเนียมเพิ่มเติม และจำนวนเงินที่เกี่ยวข้องจะถูกเพิ่มในขั้นตอนการชำระเงิน",
    "card_trans_status_fully_refund1": "เคลียร์แล้ว",
    "card_trans_status_fully_refund2": "คืนเงินทั้งหมด",
    "card_trans_status_partial_refund1": "เคลียร์แล้ว",
    "card_trans_stat_partial_refund2": "คืนเงินบางส่วน",
    "review_takes_time": "การตรวจสอบใช้เวลาตั้งแต่ 2 นาทีถึง 24 ชั่วโมง",
    "custom_date_null": "กรุณาเลือกวันที่กำหนดเอง",
    "custom_date_error": "กรุณาตั้งค่าช่วงเวลาการค้นหาให้ถูกต้อง",
    "small_trade_fee": "ค่าธรรมเนียมการทำธุรกรรมเล็กน้อย",
    "user_risk_exception": "ข้อยกเว้นสถานะผู้ใช้",
    "request_exception": "ข้อผิดพลาดในการร้องขอ",
    "mobile_is_not_empty": "กรุณาใส่หมายเลขโทรศัพท์มือถือที่ถูกต้อง",
    "code_is_not_empty": "กรุณาใส่รหัสยืนยันที่ถูกต้อง",
    "browser_paste_error": "ข้อจำกัดของเบราว์เซอร์ กรุณาป้อนด้วยตนเอง"
  }
};